import { useEffect, useState } from 'react';
import {
  Button, Col,
  InputNumber, Row,
} from 'antd';

import { Container } from 'components';

import { usePutRequest } from 'hooks';
import { getFormattedPercent } from 'utils';

export const EnhancedMatching = ({ data }: { data?: Record<string, string> }) => {
  const [value, setValue] = useState<number | null>(null);

  const [handlePatchField, { loading }] = usePutRequest({ url: '/configuration' });

  useEffect(() => {
    if (data?.['matching.percentageOfSnapsUsingAIMatching']) {
      setValue(Number(data['matching.percentageOfSnapsUsingAIMatching']));
    }
  }, [data]);

  return (
    <Container className='flex-none mb-4'>
      <h2 className='mb-10'>LLM-Enhanced Matching</h2>

      <Row wrap={false} gutter={10}>
        <Col xs={9}>
          <Row wrap={false} align='middle'>
            <Col xs={12}>
              <span>LLM-Enhanced Matching</span>
            </Col>

            <InputNumber
              min={0}
              max={100}
              step={0.01}
              value={value}
              precision={2}
              className='w-full'
              onChange={setValue}
              formatter={getFormattedPercent}
            />
          </Row>
        </Col>

        <Col flex={1}>
          <Button
            onClick={() => handlePatchField({
              callbackQueryParams: {
                key: 'matching.percentageOfSnapsUsingAIMatching',
                value,
              },
            })}
            disabled={value === null || value === undefined}
            loading={loading}
          >
            Apply
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
